import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {IApplication, IInterview} from '../../../../../assets/types/dtoTypes';
import { RescheduleInterviewResult } from '../../../../modals/interview-reschedule-modal/interview-reschedule-modal.component';

@Injectable( {
  providedIn: 'root',
} )
export class CandidateOverviewPageService {
  private http = inject(HttpClient);

  private applicationsUrl = `${environment.apiUrl}/job-applications`;

  private interviewsUrl = `${environment.apiUrl}/interviews/job-application`;

  private interviewsBaseUrl = `${environment.apiUrl}/interviews`;

  constructor() {}

  getApplication( applicationId: string ): Observable<IApplication> {
    const url = `${this.applicationsUrl}/${applicationId}`;
    return this.http.get<IApplication>( url );
  }

  getInterviewsByApplication(applicationId: string): Observable<IInterview[]> {
    const url = `${this.interviewsUrl}/${applicationId}`;
    return this.http.get<IInterview[]>(url);
  }

  requestReschedule(interviewId: string, data: RescheduleInterviewResult): Observable<IInterview> {
    return this.http.post<IInterview>(`${this.interviewsBaseUrl}/${interviewId}/reschedule`, data);
  }

  acceptInterview(interviewId: string): Observable<IInterview> {
    return this.http.post<IInterview>(`${this.interviewsBaseUrl}/${interviewId}/accept`, {});
  }

  declineInterview(interviewId: string, reason: string, notes?: string): Observable<IInterview> {
    return this.http.post<IInterview>(`${this.interviewsBaseUrl}/${interviewId}/decline`, { reason, ...(notes ? { notes } : {}) });
  }

}
